import { useState } from 'react';

// @ts-expect-error type actually correct
export const useRscFriendlyState: typeof useState = (...args) => {
  if (typeof window === 'undefined') {
    // oxlint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call
    const value = typeof args[0] === 'function' ? args[0]() : args[0];

    // oxlint-disable-next-line @typescript-eslint/no-unsafe-return
    return [
      value,
      () => {
        // empty
      },
    ];
  }

  // oxlint-disable-next-line react-hooks/rules-of-hooks
  return useState(...args);
};
